export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_ERROR = "FETCH_USER_ERROR";

const initState = {
  user: [],
};

export const fetchUser = async (credentials) => {
  //console.log(credentials);
  credentials.withoutAppOrder = true;

  var body = JSON.stringify(credentials);
  //var endpoint = "http://185.30.83.48:8095/apiPegaso/" + "/pegaso/login";
  var endpoint = global.endpoint + "/pegaso/login";
  //var endpoint = "https://dgaapi.pegasogest.it/api/" + "pegaso/login";

  return fetch(endpoint, {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    }),
    body: body,
    withCredentials: false,
  })
    .then((res) => res.json())
    .then((result) => {
      try {
        result.user.jsonVendite = JSON.parse(
          result.user?.jsonVendite?.replace("\\", "/") || "[]"
        );
      } catch (error) {
        console.log(error);
      }
      try {
        result.user.cart = JSON.parse(
          result.user?.cart?.replace("\\", "/") || "[]"
        );
      } catch (error) {
        console.log(error);
      }
      try {
        result.user.wishlist = JSON.parse(
          result.user?.wishlist?.replace("\\", "/") || "[]"
        );
      } catch (error) {
        console.log(error);
      }
      if (!result.user.username) logoutUser();
      return result;
    });
};

export const logoutUser = () => {
  return (dispatch) => {
    localStorage.removeItem("username");
    localStorage.removeItem("password");
    dispatch({ type: FETCH_USER_SUCCESS, payload: initState });
    //addToast("Accesso Effettuato", {appearance: "success", autoDismiss: true, placement: 'bottom-left' });
  };
};

export const saveUser = (user, addToast) => {
  return (dispatch) => {
    var utenteRestituito = user?.user;
    var token =
      utenteRestituito.IDCli == 0
        ? utenteRestituito.IDAge
        : utenteRestituito.IDCli;

    //if (addToast) {
    //if ((token !== undefined) && (token != 0))
    //{
    dispatch({ type: FETCH_USER_SUCCESS, payload: user });
    if (addToast)
      addToast("Accesso Effettuato", {
        appearance: "success",
        autoDismiss: true,
        placement: "bottom-left",
      });
    // //console.log("Utente Salvato con successo");
    //}
    //else
    //{
    // dispatch({ type: FETCH_USER_ERROR, payload: user });
    // if (addToast) addToast("Nome Utente o Password non Valida", {appearance: "error", autoDismiss: true, placement: 'bottom-left' });
    //  //console.log("Problemi nel Salvataggio dell'Utente");
    //  }

    //}
  };
};
